module.exports = __webpack_public_path__ + "static/media/active_home.2f91a222.svg";